import { HttpEvent, HttpEventType, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, switchMap, tap, throwError } from 'rxjs';

import { AuthService } from '@ideals/core/auth';
import { getProjectNameFromUrl } from '@ideals/utils/get-project-name-from-url';

import { ProjectsService } from '@vdr/domains/project/services/projects';

import { RequestErrorCode } from '../../models';

// This is temporary solution, that fixes problem, described in https://ideals.atlassian.net/browse/ORN-6237
// In future this logic will be handled in Auth microservice, so FE won't need to refresh token manually on ToU changes
export function tokenRefreshInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const authService = inject(AuthService);
  const projectsService = inject(ProjectsService);
  const url = inject(Router).url;

  return next(request).pipe(
    tap((event) => {
      if (event.type === HttpEventType.Response && request.headers.has('X-Token-Refresh-Required')) {
        authService.refreshToken()
          .subscribe(() => {
            next(request);
          });
      }
    }),
    catchError((error: unknown) => {
      if (
        !!error
        && typeof error === 'object'
        && 'errorCode' in error
        && error.errorCode === RequestErrorCode.Auth_AccessClaimMissing
      ) {
        const hostId = url.match(/\/project\/(\d+)\//)?.[1];
        const projectName = getProjectNameFromUrl(url);

        if (hostId && projectName) {
          return projectsService.loadProject(hostId!, projectName) // dumb request to vdr (don't ask why, BE says that it's required)
            .pipe(
              switchMap(() => next(request)),
            );
        }

        return throwError(() => error);
      }

      return throwError(() => error);
    }),
  );
}
